// extracted by mini-css-extract-plugin
export var body = "BetRow-module--body--49ca7";
export var iconSlot = "BetRow-module--iconSlot--afed8";
export var market = "BetRow-module--market--a77df";
export var name = "BetRow-module--name--84a31";
export var rightSlot = "BetRow-module--rightSlot--3c3e4";
export var row = "BetRow-module--row--8e3d7";